import { h } from 'preact'; /** @jsx h */
import formatPrice from '../../utils/formatPrice';

import './Orderline.scss';

const Orderline = ({ item }) => {
    let price = item.donation || item.inputPrice || item.price;
    const qty = parseInt(item.qty);

    if (typeof price === 'string') {
        price = price.replace(',', '');
        price = parseFloat(price);
    }

    return (
        <div
            className={`ws-order-item item-${item.id}-${item.qty}-${item.inputPrice}`}
            key={item.id}
        >
            <div className="ws-item-img">
                <img src={item.imageUrl} alt={item.name} />
            </div>
            <div className="ws-item-info">
                <div className="ws-item-title">
                    <h5>{item.name}</h5>
                </div>
                <div className="ws-item-content">
                    <p>
                        {item.id === 150
                            ? 'Ingen leveringsmetode'
                            : item.catName === 'Produkter'
                            ? 'Produkt i posten'
                            : item.shipmentType}
                    </p>
                    <p>{item.taxDeduction ? 'Fradragsberettiget' : 'Ikke fradragsberettiget'}</p>
                </div>
            </div>
            <div className="ws-item-handle">
                <div className="ws-handle-top">
                    <p>
                        Pris: {formatPrice(price / qty)}
                        ,-
                    </p>
                </div>
                <div className="ws-handle-mid">
                    <p>Antall: {item.qty} stk.</p>
                </div>
                <div className="ws-handle-bottom">
                    <p>
                        Delsum: {formatPrice(price)}
                        ,-
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Orderline;
